import { KTIcon } from '../../../_elfaiotbbx/helpers'
import { Link, useLocation } from 'react-router-dom'
import { PercentTable } from './PercentTable'

/**
 * "Yaklasik Kullanim Omru" ekrani.
 *
 * <h2>Buraya nasil geliniyor</h2>
 *
 * Bu bir karakutu SEKMESI DEGIL. Tek gercek giris noktasi: Raporlar sekmesi ->
 * "Vinc Analiz" karti -> "Cihaz Kullanim Hesaplama Sistemleri" bolumundeki ok
 * dugmesi (`WorkingTimeList.tsx`). O baglanti `location.state` ile `uid` ve
 * `deviceDescription` tasiyor, yani ekran bir CIHAZA ait.
 *
 * Ekrandaki ad "Vinc Analiz"; `WorkingTimeList` yalnizca bilesenin adi. Ayni
 * kartta iki bolum daha var ve ayri sayfalara gidiyorlar: "Fem-1"
 * (`profile/fem1`) ve "Yuk Kontrol Sistemleri" (`reparation/indicatorreparation`).
 *
 * `uid` state'ten geldigi icin adrese dogrudan girildiginde (ya da sayfa
 * yenilendiginde) bos olur; PercentTable bu durumu artik ayri bir mesajla
 * gosteriyor, bos tablo yerine.
 */
const ReparationMainWindowList = () => {
  const location = useLocation();
  const uid = (location.state as { uid?: string })?.uid;
  const deviceDescription = (location.state as { deviceDescription?: string })?.deviceDescription;

  return (
    <>
      <div className='row g-5 g-xl-8'>
        <div className='col-xl-4'>
          {/* Kart ekleme ekranina gecerken yalnizca `uid` tasiniyor.
              Onceden `indicatorList:{indicatorList}` da gonderiliyordu ve iki
              sorunu vardi: deger FAZLADAN BIR NESNEYE sarilmisti (alici
              `state.indicatorList.indicatorList` okumak zorunda kalirdi) ve
              AddReparation bu alani hic okumuyor. */}
          <Link
            state={{ uid: uid }}
            to={`/crafted/reparation/addreparation`}
            className={`card bg-body-white hoverable card-xl-stretch mb-xl-8`}>
            <div className='card-body'>
              <KTIcon iconName='plus' className={`text-primary fs-3x ms-n1`} />

              <div className={`text-gray-900 fw-bold fs-2 mb-2 mt-5`}>Kart ekle</div>

              <div className={`fw-semibold text-gray-400`}>Elektronik ve ya mekanik sistem kontrolü</div>
            </div>
          </Link>
        </div>
      </div>

      <div className='row gy-5 g-xl-8'>
        <PercentTable className='card-xl-stretch mb-xl-8' uid={uid} deviceDescription={deviceDescription} />
      </div>
    </>
  )
}

export { ReparationMainWindowList }
